import { ContactFragment } from '../generated/graphql';

export const formatContact = (contact: ContactFragment) => {
  const { name, company, email, phone } = contact;
  let formattedName = name;
  if (company && company.trim().length > 0) {
    formattedName += ', ' + company;
  }
  if (email && email.trim().length > 0) {
    formattedName += ', ' + email;
  }
  if (phone && phone.trim().length > 0) {
    formattedName += ', ' + phone;
  }
  return formattedName;
};
